import { connect } from 'react-redux'
import {
  selectCurrentPage,
  selectTotalPages,
  selectIsTicketSelectionMode,
  selectIsLoadingMoreTickets,
} from 'selectors/ticket_list'
import {
  selectIsTicketsCurtainVisible,
  selectPreviousScrollY,
} from 'selectors/app'
import { selectHasCurrentTicketSearchLoaded } from 'selectors/search/base'
import {
  selectCurrentTicketSearchResultTicketIds,
  selectCurrentTicketSearchQueryString,
  selectCurrentTicketSearchResultTicketCount,
} from 'selectors/search'
import { selectCurrentTicketId } from 'selectors/tickets'

import { selectSelectedTicketIds } from 'selectors/ticket_list/base'
import {
  doToggleTicketSelection,
  doRangedTicketSelection,
  doListTopChanged,
} from 'actions/app'
import { doNavigateToTicket } from 'actions/navigation'
import { doOpenTicketPage } from 'actions/pages'
import {
  doFetchCurrentFolderWithTicketsNextPage,
  doMarkBulkSelectionMode,
  doCloseTicket,
  doOpenTicket,
} from 'actions/tickets'
import { doLoadUnloadedSearchTickets } from 'actions/load'
import { doLoadIncompleteSearch } from 'actions/search'

import ConversationList from 'components/ConversationList'
import TicketListItem from './ListItem'
import TicketEmptyState from './EmptyState'

const select = state => {
  return {
    hasLoaded: selectHasCurrentTicketSearchLoaded(state),
    canLoadMore: selectCurrentPage(state) < selectTotalPages(state),
    isLoadingMore: selectIsLoadingMoreTickets(state),
    isSelectionMode: selectIsTicketSelectionMode(state),
    isConversationsCurtainVisible: selectIsTicketsCurtainVisible(state),
    scrollY: selectPreviousScrollY(state),
    selectedConversationIds: selectSelectedTicketIds(state),
    conversationIds: selectCurrentTicketSearchResultTicketIds(state),
    currentConversationId: selectCurrentTicketId(state),
    ListItem: TicketListItem,
    EmptyState: TicketEmptyState,
    conversationListQueryKey: selectCurrentTicketSearchQueryString(state),
    totalCount: selectCurrentTicketSearchResultTicketCount(state),
  }
}

const onListLoaded = () => {
  return dispatch => {
    dispatch(doLoadUnloadedSearchTickets())
    dispatch(doLoadIncompleteSearch())
  }
}

const perform = {
  markBulkSelectionMode: doMarkBulkSelectionMode,
  openConversationPage: doOpenTicketPage,
  toggleConversationSelection: doToggleTicketSelection,
  onRangedSelection: doRangedTicketSelection,
  loadMore: doFetchCurrentFolderWithTicketsNextPage,
  onTopChanged: doListTopChanged,
  closeConversation: doCloseTicket,
  openConversation: doOpenTicket,
  navigateToConversation: doNavigateToTicket,
  onListLoaded,
}

export default connect(select, perform)(ConversationList)
